import React from 'react';
import PropTypes from 'prop-types';
import Box from '../../../box';
import Stack from '../../../stack';
import Heading from '../../../heading';
import InputGroup from '../../../input-group';
import ActionButton from '../../../action-button';
import FieldStatus from '../../../field-status';
import useMatchMDBreakpoint from '../../../../hooks/use-match-md-breakpoint';

const DomainSelectorConnectThirdParty = ({
  captions,
  value = '',
  errorMessage = '',
  onButtonClick,
  onBlur,
  onChange,
}) => {
  const isMd = useMatchMDBreakpoint();

  return (
    <div className="ws-ui-domain-selector-connect-third-party">
      <Box
        paddingTop="spacing-2-xs"
        paddingBottom="spacing-xs"
        paddingLeft="spacing-xs"
        paddingRight="spacing-xs"
        breakpoints={{
          md: {
            paddingTop: 'spacing-s',
            paddingBottom: 'spacing-m',
            paddingLeft: 'spacing-m',
            paddingRight: 'spacing-m',
          },
        }}
      >
        <Stack gap="spacing-2-xs">
          <Heading type="heading-5">{captions.title}</Heading>
          <div className="ws-ui-domain-selector-connect-third-party__input-container">
            <div className="ws-ui-domain-selector-connect-third-party__input">
              <InputGroup
                size="large"
                value={value}
                invalid={Boolean(errorMessage)}
                placeholder={captions.inputPlaceholder}
                onChange={onChange}
                onBlur={onBlur}
              />
              {errorMessage && <FieldStatus text={errorMessage} appearance="error" />}
            </div>
            <div>
              <ActionButton
                format="solid"
                size="large"
                label={captions.actionButtonLabel}
                disabled={Boolean(errorMessage)}
                {...(!isMd && { fontSize: 'large', fullWidth: true })}
                onClick={onButtonClick}
              />
            </div>
          </div>
        </Stack>
      </Box>
    </div>
  );
};

DomainSelectorConnectThirdParty.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    inputPlaceholder: PropTypes.string,
    actionButtonLabel: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  onButtonClick: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DomainSelectorConnectThirdParty;
